import { styled } from "styled-components";

import { Avatar } from "../Avatar";
import { Button as _Button } from "../Button";
import { Icon } from "../Icon";
import { textOverflowStyles } from "../../styles";

export const Title = styled.div(({ theme }) => ({
  ...(textOverflowStyles as any),
  margin: 0,
  fontSize: "17px",
  fontWeight: theme.fontWeights["2"],
  // Single-line box: line-height matches the fixed height so the title cannot
  // be clipped by an inherited line-height.
  height: theme.lineHeights["2"],
  lineHeight: theme.lineHeights["2"],
  color: "rgba(255,255,255,0.95)",
}));

export const Button = styled(_Button.BaseButton)(({ theme }) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 32,
    width: 32,
    marginLeft: 8,
    borderRadius: 6,
    background: "none",
    transition: "background-color 0.25s",

    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.16)",

      [`& ${Icon.Frame}`]: {
        color: theme.colors.white,
      },
    },

    [`& ${Icon.Frame}`]: {
      height: theme.sizes.xxs,
      width: theme.sizes.xxs,
      color: "rgba(255,255,255,0.8)",
      transition: "color 0.25s",
    },
  };
});

export const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexShrink: 0,
  alignItems: "center",
  height: theme.sizes.lg,
  padding: `0 ${theme.space["4"]} 0 ${theme.space["5"]}`,
  backgroundColor: theme.colors.primary,
  boxShadow: `0 2px 8px ${theme.shadows["32"]}`,
  zIndex: 1,

  [`& ${Avatar.Container}`]: {
    height: 32,
    width: 32,
  },

  [`& ${Title}`]: {
    flex: 1,
    margin: "0 0 0 14px",
  },
}));
